// const {
//   createPaginationContainer,
//   graphql,
// } = require('react-relay');

import React from 'react';
import Relay from 'react-relay';

import Button from '../../components/Button';
import SportunityTable from '../../components/SportunityTable';

const pageSize = 50;

class SportunitiesList extends React.Component {

    state = {
      loading: false
    }

    constructor(props) {
        super(props);
    }

    componentDidMount(){
        //this.componentWillReceiveProps(this.props)
    }

    componentWillReceiveProps(nextProps) {
      this.hasNextPage = nextProps.viewer.next ? nextProps.viewer.next.pageInfo.hasNextPage : this.hasNextPage;
      this.hasPreviousPage = nextProps.viewer.prev ? nextProps.viewer.prev.pageInfo.hasPreviousPage : this.hasPreviousPage;

      if (this.state.loading) return false

      const {
        searchBySport: { id: sportID, level } = {},
        searchByOrganizeId,
        searchByPublicKind,
        dateFrom,
        dateTo
      } = nextProps
      const variables = {}
      const filter = this.props.relay.variables.filter || {}

      

      const relayFilter = this.props.relay.variables.filter || {}
      const relayVars = this.props.relay.variables

      if (sportID && (
          (sportID != (relayFilter.sport || {}).sportID) ||
          (level != (relayFilter.sport || {}).level)
        )) {
        filter.sport = { sportID, level }
      } else if (relayFilter.sport && !sportID) {
        filter.sport = null
      }

      if (searchByOrganizeId && (
          !relayFilter.users ||
          relayVars.userId !== searchByOrganizeId
        )
      ) {
        variables.userId = searchByOrganizeId
        filter.status = 'Organized'
      } else if (relayVars.userId && !searchByOrganizeId) {
        variables.userId = null
        filter.status = null
      }

      if (searchByPublicKind && searchByPublicKind != relayFilter.kind) {
        filter.kind = searchByPublicKind
      } else if (relayFilter.kind && !searchByPublicKind) {
        filter.kind = null
      }

      if (dateFrom && dateTo) {
        filter.dates = {
          from: dateFrom,
          to: dateTo
        }
      }

      if (Object.keys(variables).length || Object.keys(filter).length) {
        this.setState({
          loading: true,
        })
        this.props.relay.setVariables({
          ...variables,
          filter,
          next: !this.props.relay.variables.prev ? true : false,
        }, (state) =>
          (state.done || state.aborted) && this.setState({
            loading: false,
          })
        )
      }
    }

    nextPage() {
        this.hasPreviousPage = true;
        const pageInfo = this.props.viewer.next ? this.props.viewer.next.pageInfo : this.props.viewer.prev.pageInfo;
        const cursor = pageInfo.endCursor;
        this.props.relay.setVariables({ after: cursor, next: true, prev: false });
    }

    prevPage() {
        this.hasNextPage = true;
        const pageInfo = this.props.viewer.next ? this.props.viewer.next.pageInfo : this.props.viewer.prev.pageInfo;
        const cursor = pageInfo.startCursor;
        this.props.relay.setVariables({ before: cursor, next: false, prev: true });
    }

    assetEdges() {
        // get the next edges or the prev edges, or just get an empty array
        // this.props.viewer.sportunities.edges
        return (this.props.viewer ?
            (this.props.viewer.next ? this.props.viewer.next.edges :
                (this.props.viewer.prev ? this.props.viewer.prev.edges : []))
            : [])
    }

    onEditSportunityClick = (item, index, event) => {
      event.stopPropagation()
      if(item == this.props.location.state.sportunity){
          return;
      }

      let path = '/sportunities/edit/'+item.id;
      this.props.router.push({
        pathname : path,
        state :{
          relay:this.props.relay,
          edit: true,
        }
      })
    }

    onSportunityClick = (item, index, event) => {
        if(item == this.props.location.state.sportunity){
            return;
        }

        let path = '/sportunities/edit/'+item.id;
        this.props.router.push({
            pathname : path,
            state :{
                relay:this.props.relay,
                edit: false,
            }
        })
    }

    _getFilterDate() {
        //return {};
        let filterFrom = this.props.location.state.dateFrom;
        let filterTo = this.props.location.state.dateTo;

        return {filterFrom, filterTo};
    }

    onChangeOrder = order => this.props.relay.setVariables({
      order,
      next: true,//order.search('ASC') >= 0 ? true : false, 
      prev: false, //order.search('ASC') >= 0 ? false : true, 
      first: pageSize, //order.search('ASC') >= 0 ? pageSize : null,
      last: 0,//order.search('ASC') >= 0 ? null : pageSize,
      after: null,
      before: null,
    })

    render() {
      if (this.state.loading) return (<div>Loading...</div>)
      const prevButton = this.hasPreviousPage ? <button onClick={ this.prevPage.bind(this) }>prev page</button> : '';
      const nextButton = this.hasNextPage ? <button onClick={ this.nextPage.bind(this) }>next page</button> : '';

      // const sportunities = this.props.viewer.sportunities.edges;
      const sportunities = this.assetEdges();
      const filters = this._getFilterDate();

      return (
        <div>
          <div style={{marginTop:20}}>
            <SportunityTable
              dataSource={sportunities}
              filters={filters}
              onItemClick={this.onSportunityClick}
              onEditItemClick={this.onEditSportunityClick}
              onChangeOrder={this.onChangeOrder}
              currentOrder={this.props.relay.variables.order}
            />
          </div>
            {this.props.children}
            { prevButton }
            { nextButton }
        </div>
      )
    }
}


SportunitiesList.propTypes = ({
    viewer: React.PropTypes.object.isRequired,
    relay: React.PropTypes.object.isRequired,
    children: React.PropTypes.node,
});


export default Relay.createContainer(SportunitiesList, {
    initialVariables: {
        first: pageSize,
        last: pageSize,
        after: null,
        before: null,
        next: false,
        prev: false,
        filter: null,
        userId: null,
        order: 'CREATION_DATE_DESC'
    },

    fragments: {
        viewer: () => Relay.QL`
      fragment on Viewer {
        next: sportunities(first: $first, after: $after, filter: $filter, userId: $userId, orderBy: $order) @include(if: $next) {
          edges {
            node {
              id
              title
              description
              address {
                address
                city
                country
              }
              venue {
                name
                address {
                  address
                  city
                  country
                }
                owner {
                  pseudo
                }
              }
              price {
                cents
                currency
              }
              mode
              kind
              ageRestriction {
                from
                to
              }
              sexRestriction
              participantRange {
                from
                to
              }
              creation_status {
                status,
                reason
              }
              sport {
                levels {
                  EN {
                    name
                  }
                }
                allLevelSelected
                sport {
                  logo
                  name {
                    EN
                  }
                }
              }
              organizers {
                organizer {
                  pseudo
                }
                isAdmin
                role
              }
              beginning_date
              ending_date
              creation_date,
              cancel_date
            }
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
        }
        prev: sportunities(last: $last, before: $before, filter: $filter, userId: $userId, orderBy: $order) @include(if: $prev) {
          edges {
            node {
              id
              title
              description
              address {
                address
                city
                country
              }
              venue {
                name
                address {
                  address
                  city
                  country
                }
                owner {
                  pseudo
                }
              }
              price {
                cents
                currency
              }
              mode
              kind
              ageRestriction {
                from
                to
              }
              sexRestriction
              participantRange {
                from
                to
              }
              creation_status {
                status,
                reason
              }
              sport {
                levels {
                  EN {
                    name
                  }
                }
                allLevelSelected
                sport {
                  logo
                  name {
                    EN
                  }
                }
              }
              organizers {
                organizer {
                  pseudo
                }
                isAdmin
                role
              }
              beginning_date
              ending_date
              creation_date,
              cancel_date
            }
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
        }

      }
    `,
}
});



// WEBPACK FOOTER //
// ./src/pages/Sportunity/SportunitiesList.js